import React, { useState } from "react";
import IOwDivTableCols from "./IOwDivTableCols";
import OwLabel from "../OwLabel/OwLabel";
import styled from "styled-components";
import { v4 } from "uuid";

type Props = {
    cols: IOwDivTableCols[];
    data: any[];
    colClassName?: string;
    rowClassName?: string;
};

const TableHeader = styled.div`
    display: flex;

    & > div {
        padding: 0.5rem;
    }
`;

const TableRow = styled.div`
    display: flex;

    & > div {
        padding: 0.5rem;
    }

    &:hover {
        background-color: var(--table-hover-row);
    }
`;

export const OwDivTable: React.FC<Props> = (props) => {
    const [colWidth, setColWidth] = useState(100 / props.cols.length);

    return (
        <div className={"OwDivTable shadow p-2"}>
            <TableHeader className={"border-bottom"}>
                {props.cols.map((col, index) => {
                    return (
                        <div key={v4()} className={col.className || props.colClassName}>
                            {col.hideTitle ? null : <OwLabel title={col.title} isBold={true} />}
                        </div>
                    );
                })}
            </TableHeader>
            {props.data.map((item, dataIndex) => {
                return (
                    <TableRow key={v4()} className={props.rowClassName}>
                        {props.cols.map((col, index) => {
                            return (
                                <div key={v4()} className={col.className || props.colClassName}>
                                    {col.renderFn(item, dataIndex)}
                                </div>
                            );
                        })}
                    </TableRow>
                );
            })}
        </div>
    );
};
